/* ============================================================
   C.S. SINGHI & ASSOCIATES — Content source-of-truth
   Every block below is placeholder-editable for the client.
   ============================================================ */

export const ASSETS = {
  hero: "https://customer-assets.emergentagent.com/job_himalayan/artifacts/q8fnvl8v_image.png",
  logo: "https://customer-assets.emergentagent.com/job_6eb074fe-1740-4003-b10a-e49bd9643602/artifacts/17tvwskj_logo.png",
  logoIcon: "https://customer-assets.emergentagent.com/job_himalayan/artifacts/ndakjvqy_image.png",
  logoFull: "https://customer-assets.emergentagent.com/job_himalayan/artifacts/jl0u46ay_image.png",
  contactBg: "https://customer-assets.emergentagent.com/job_himalayan/artifacts/lwg6479m_image.png",
};

/* CONTENT: Architectural photos used for collage + project cards.
   Swap with admin building/ photos when available. */
export const STOCK_PHOTOS = {
  collage1:
    "https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=1200&q=80&auto=format&fit=crop",
  collage2:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80&auto=format&fit=crop",
  collage3:
    "https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=1200&q=80&auto=format&fit=crop",
  himalayanHeights:
    "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&q=80&auto=format&fit=crop",
  skylineResidency:
    "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=80&auto=format&fit=crop",
  skyGangtok:
    "https://images.unsplash.com/photo-1486718448742-163732cd1544?w=1200&q=80&auto=format&fit=crop",
};

export const NAV_LINKS = [
  { id: "about", label: "About" },
  { id: "services", label: "Practice" },
  { id: "projects", label: "Projects" },
  { id: "team", label: "Team" },
  { id: "careers", label: "Careers" },
];

export const VALUES = [
  {
    name: "Radical Transparency",
    desc: "Open books on material costs and structural audits — clients have full visibility into every rupee and every rod of steel.",
  },
  {
    name: "Statutory Integrity",
    desc: "Twenty-five years of unblemished practice. Strict adherence to COA norms and local bye-laws — zero legal liabilities for clients.",
  },
  {
    name: "Contextual Responsibility",
    desc: "Every design respects the fragile Himalayan ecosystem — prioritising slope stability and indigenous materials.",
  },
  {
    name: "Community Trust",
    desc: "Our projects are designed to contribute positively to the urban fabric of Gangtok, and to the lives of the people who inherit them.",
  },
];

export const STATS = [
  { value: 25, suffix: "", label: "Years of Practice" },
  { value: 100, suffix: "+", label: "Flagship Developments" },
  { value: 3, suffix: "", label: "Company Landmarks" },
  { value: 100, suffix: "%", label: "Turnkey Delivery" },
];

export const TIMELINE = [
  { year: "2001", title: "The Beginning",       desc: "Founded in Gangtok" },
  { year: "2006", title: "Building Foundations", desc: "Expansion of early projects" },
  { year: "2012", title: "Expanding Horizons",  desc: "Growth across sectors" },
  { year: "2018", title: "Designing Landmarks", desc: "Major regional developments" },
  { year: "2026", title: "Shaping Tomorrow",    desc: "Silver Jubilee milestone" },
];

export const PROBONO = [
  {
    name: "Enchey Gumpa",
    location: "Gangtok · Sikkim",
    desc: "One of Gangtok's oldest monasteries — a sacred seat of the Nyingma order. We contributed complete architectural design pro bono, honouring spiritual heritage while ensuring structural resilience.",
  },
  {
    name: "Anjuman Islam Mosque",
    location: "Gangtok · Sikkim",
    desc: "Serving Gangtok's Muslim community for generations. Full architectural services provided at no cost — blending traditional Islamic design principles with locally appropriate construction.",
  },
  {
    name: "Tamang Gumpa",
    location: "Ranka · East Sikkim",
    desc: "A spiritual anchor for the local Tamang community. Designed free of charge — respecting the delicate ecology of the region and the cultural traditions of its people.",
  },
];

export const SERVICES = [
  {
    num: "01",
    name: "Architectural & Interior Design",
    desc: "Complete turnkey execution — from blueprint to final brick, materials and labour included.",
  },
  {
    num: "02",
    name: "Turnkey Projects",
    desc: "Strategic land sourcing and topographic planning for high-value commercial and residential developments.",
  },
  {
    num: "03",
    name: "Property Valuations",
    desc: "Exclusive listings and property management for Gangtok's most sought-after addresses.",
  },
  {
    num: "04",
    name: "Real Estate",
    desc: "Curated portfolio of premium properties — sourced, vetted, and represented end-to-end.",
  },
  {
    num: "05",
    name: "Commercial Development",
    desc: "Mixed-use, retail, and hospitality — engineered to thrive in the Himalayan context.",
  },
  {
    num: "06",
    name: "Site Evaluation & Consultation",
    desc: "Geotechnical, climatic, and statutory analysis before the first line is drawn.",
  },
];

export const PROJECTS = [
  {
    id: "sky-gangtok",
    index: "01",
    title: "Sky Gangtok",
    location: "Gangtok, Sikkim",
    year: "2021 – Present",
    status: "UNDER CONSTRUCTION",
    statusVariant: "construction",
    area: "90,000+ sq ft",
    image:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/34qf8exv_Screenshot%202026-06-26%20at%204.14.45%E2%80%AFPM.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/34qf8exv_Screenshot%202026-06-26%20at%204.14.45%E2%80%AFPM.png",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/t9rjnza1_Screenshot%202026-06-26%20at%204.25.13%E2%80%AFPM.png",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/55dfdxz8_Screenshot%202026-06-26%20at%204.25.59%E2%80%AFPM.png",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/6iw8e7d2_Screenshot%202026-06-26%20at%204.15.36%E2%80%AFPM.png",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/nf6083ar_Screenshot%202026-06-26%20at%204.15.16%E2%80%AFPM.png",
    ],
    description:
      "Gangtok's first premium high-rise — residential with attached commercial space and unparalleled amenities.",
  },
  {
    id: "tnsa-admin-block",
    index: "02",
    title: "Tashi Namgyal Academy Admin Block",
    location: "Gangtok, Sikkim",
    year: "2021",
    status: "COMPLETE",
    statusVariant: "wood",
    area: "approx 20,000 sq ft",
    image:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/yve47y2g_IMG_1970.JPG",
    gallery: [
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/yve47y2g_IMG_1970.JPG",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/xlechuiz_IMG_1972.JPG",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/snsvmafq_IMG_1975.JPG",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/545lhew8_IMG_1976.JPG",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/rf7nyixg_IMG_1979.JPG",
    ],
    description:
      "Purpose-built Admin Block for Tashi Namgyal Academy — relocated from the Senior School into a dedicated home for the institution's administration.",
  },
  {
    id: "tashi-namgyal-washrooms",
    index: "03",
    title: "Tashi Namgyal Academy Washroom Renovation",
    location: "Gangtok, Sikkim",
    year: "2025 – 2026",
    status: "COMPLETE",
    statusVariant: "wood",
    area: "1,657 sq ft (total)",
    image: "/projects/tashi/tashi-6.jpg",
    gallery: [
      "/projects/tashi/tashi-6.jpg",
      "/projects/tashi/tashi-7.jpg",
      "/projects/tashi/tashi-8.jpg",
      "/projects/tashi/tashi-9.jpg",
      "/projects/tashi/tashi-17.jpg",
      "/projects/tashi/tashi-20.jpg",
      "/projects/tashi/tashi-26.jpg",
    ],
    description:
      "Three-phase washroom renovation at Tashi Namgyal Academy — material-led detail, restored dignity.",
    phases: [
      {
        label: "Junior Boys",
        area: "637.13 sq ft",
        period: "Jan 2026 – Feb 2026",
      },
      {
        label: "Junior Girls",
        area: "672.61 sq ft",
        period: "Dec 2025 – Feb 2026",
      },
      {
        label: "Senior Boys",
        area: "347.54 sq ft",
        period: "Nov 2025 – Jan 2026",
      },
    ],
  },
  {
    id: "hotel-gangtok-drift",
    index: "04",
    title: "Hotel Gangtok Drift",
    location: "Gangtok, Sikkim",
    year: "2014",
    status: "COMPLETE",
    statusVariant: "wood",
    area: "12,000 sq ft",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/8bven2jl_WhatsApp%20Image%202026-07-30%20at%2005.46.34.jpeg",
    gallery: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/8bven2jl_WhatsApp%20Image%202026-07-30%20at%2005.46.34.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/6pfw7dt6_WhatsApp%20Image%202026-07-30%20at%2005.46.29.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/2ntkn64c_WhatsApp%20Image%202026-07-30%20at%2005.46.36%20%281%29.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/supltz99_WhatsApp%20Image%202026-07-30%20at%2005.46.37%20%281%29.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/biajipdd_WhatsApp%20Image%202026-07-30%20at%2005.46.37.jpeg",
    ],
    description:
      "A boutique hotel + restro on Gangtok's high street — warm lobby detailing, contemporary rooms and a quiet urban rhythm.",
  },
  {
    id: "moe-beautiful",
    index: "05",
    title: "Mo-e Beautiful",
    location: "M.G. Marg, Gangtok",
    year: "2025",
    status: "COMPLETE",
    statusVariant: "wood",
    area: "1,900 sq ft",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/jlb6ha1a_WhatsApp%20Image%202026-07-30%20at%2005.46.53.jpeg",
    gallery: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/jlb6ha1a_WhatsApp%20Image%202026-07-30%20at%2005.46.53.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/wlcvlty0_WhatsApp%20Image%202026-07-30%20at%2005.46.56.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/9vobd1lo_WhatsApp%20Image%202026-07-30%20at%2005.46.51.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/rnzskhoj_WhatsApp%20Image%202026-07-30%20at%2005.46.49.jpeg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/y6fou013_WhatsApp%20Image%202026-07-30%20at%2005.46.48.jpeg",
    ],
    description:
      "A cosmetics showroom on M.G. Marg — rose-gold archways, glass-lit shelving and a retail experience shaped for beauty.",
  },
  {
    id: "ramesh-jewellers",
    index: "06",
    title: "Ramesh Jewellers",
    location: "Tibet Rd, Gangtok",
    year: "2026",
    status: "IN PROGRESS",
    statusVariant: "construction",
    area: "230 sq ft",
    image:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/ulpjx5nj_PHOTO-2026-08-21-15-52-57.jpg",
    gallery: [
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/ulpjx5nj_PHOTO-2026-08-21-15-52-57.jpg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/cjpa8dvd_PHOTO-2026-08-21-15-52-57.jpg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/52fyww2y_PHOTO-2026-08-21-15-52-57.jpg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/pnnjitz1_PHOTO-2026-08-21-15-52-56.jpg",
      "https://customer-assets-cm19k8pv.emergentagent.net/job_himalayan/artifacts/xjuxlhqb_PHOTO-2026-08-21-15-52-58.jpg",
    ],
    description:
      "Interior design for a jewellery store on Tibet Road — considered lighting, layered display and a quietly refined retail atmosphere.",
  },
  {
    id: "golden-heights",
    index: "07",
    title: "Golden Heights",
    location: "Gangtok, Sikkim",
    year: "2024",
    status: "COMPLETE",
    statusVariant: "wood",
    area: "Hotel + Retail",
    image:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/k909uv7w_image.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/k909uv7w_image.png",
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/kca1uij0_image.png",
    ],
    description:
      "Hotel Golden Heights — a mixed-use façade on Gangtok's high street, animated by porthole windows and layered chhajjas.",
  },
];

export const TEAM_LEADS = {
  principal: {
    eyebrow: "Founding Principal",
    name: "Ar. Chhatra S. Singhi",
    role: "Proprietor · Architect",
    initials: "CS",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/8d6c868i_Chhatra.png",
    quote:
      "True architecture is measured not just in structures, but in the ethical foundation upon which they are built.",
  },
  architect: {
    eyebrow: "Architect",
    name: "Ar. Saakshi Singhi",
    role: "Studio Lead",
    initials: "SS",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/31srbk52_Saakshi%20Singhi.png",
    quote:
      "Every building we draw is a quiet promise — to the land that holds it, and the family that will live inside.",
  },
};

export const TEAM_GRID = [
  {
    name: "Yorika Moktan",
    role: "Architect",
    initials: "YM",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/rbygv805_Yorika%20.png",
  },
  {
    name: "Chelsea Palmo Bhutia",
    role: "Architect",
    initials: "CB",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/9i8hmnwp_Chelsea.png",
  },
  {
    name: "Rikzum Rinchen Bhutia",
    role: "Architect",
    initials: "RB",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/d9z6daha_Rikzum.jpg",
  },
  {
    name: "Jessica Tiruwa",
    role: "Civil Engineer",
    initials: "JT",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/ewoa0gzc_Jessica.png",
  },
  {
    name: "Dawa Bhutia",
    role: "Civil Draftsman",
    initials: "DB",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/igd9drqo_Dawa%20Bhutia.png",
  },
  {
    name: "Deepak Tamang",
    role: "Civil Engineer (Diploma)",
    initials: "DT",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/2sr0tdgy_Deepak%20Tamang.png",
  },
];

export const SUPPORT_TEAM = [
  {
    name: "Prakash Subba",
    role: "Site Inspector",
    initials: "PS",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/oeli9553_Prakash.png",
  },
  {
    name: "Shalini Upadhay",
    role: "Accountant",
    initials: "SU",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/it12dn11_Shalini.png",
  },
  {
    name: "Aruna Chettri",
    role: "Manager",
    initials: "AC",
    photo:
      "https://customer-assets.emergentagent.com/job_himalayan/artifacts/5n712pzl_Aruna%20Chettri%20.png",
  },
  { name: "Puspa Nirola", role: "Assistant Manager", initials: "PN", photo: "https://customer-assets.emergentagent.com/job_himalayan/artifacts/2omozoc7_Pushpa.png" },
];

export const JOBS = [
  {
    title: "Junior Architect",
    type: "Full-Time",
    location: "Gangtok, Sikkim",
    responsibilities: [
      "Develop architectural drawings and technical documentation",
      "Collaborate on design concepts from brief to construction",
      "Conduct site visits and coordinate with contractors",
    ],
    requirements: [
      "B.Arch or M.Arch degree",
      "Proficiency in AutoCAD, Revit, or ArchiCAD",
      "Strong portfolio demonstrating spatial thinking",
    ],
  },
  {
    title: "Senior Interior Designer",
    type: "Full-Time",
    location: "Gangtok, Sikkim",
    responsibilities: [
      "Lead end-to-end interior design projects",
      "Develop material palettes, furniture specs, and lighting plans",
      "Client presentations and design iteration",
    ],
    requirements: [
      "5+ years of interior design experience",
      "Mastery of SketchUp, 3ds Max, or equivalent",
      "Experience with high-end residential or hospitality",
    ],
  },
  {
    title: "Project Execution Manager",
    type: "Contract",
    location: "On-Site · Gangtok",
    responsibilities: [
      "Oversee on-site construction and quality compliance",
      "Coordinate between design team, contractors, and clients",
      "Track milestones, budgets, and material delivery",
    ],
    requirements: [
      "Civil engineering background preferred",
      "5+ years of site execution experience",
      "Strong communication and problem-solving",
    ],
  },
];

export const CONTACT = {
  address: "Lal Market Rd, Gangtok, Sikkim 737101, India",
  phone: "+91 9749100766",
  email: "office@cssinghi.com",
  whatsapp: "+91 9749100766",
};

/* CONTENT: About narrative paragraph (editable) */
export const ABOUT_BODY = `Founded in 2001 in Gangtok, Sikkim, C.S. Singhi & Associates has spent twenty-five years shaping the Himalayan skyline with integrity, innovation, and trust. From sacred monasteries to luxury residences, every project begins with a single commitment: architecture must serve the land, the people, and the generations that follow.`;
